import { render, staticRenderFns } from "./appstore-notification.vue?vue&type=template&id=a80c4246&scoped=true&"
import script from "./appstore-notification.vue?vue&type=script&lang=js&"
export * from "./appstore-notification.vue?vue&type=script&lang=js&"
import style0 from "./appstore-notification.vue?vue&type=style&index=0&id=a80c4246&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80c4246",
  null
  
)

export default component.exports